import pick from "lodash/pick";
import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import unset from "lodash/fp/unset";
import merge from "lodash/merge";
import get from "lodash/get";
import keys from "lodash/keys";
import { CHECKOUT_CONTEXT_ENUM } from "./actions/global.actions";
import { defaultAdminIntegrationName } from "../httpService";
import { ADMIN_SETTINGS_KEY } from "../components/BookingForm/booking-form.helpers";
export var STORE_KEY = 'ws-book';
var storage = {
    localStorage: {},
    sessionStorage: {}
};
export var getSessionStore = function (name) {
    try {
        return sessionStorage.getItem(name);
    }
    catch (e) {
        // console.error(e);
        return get(storage.sessionStorage, name);
    }
};
export var setSessionStore = function (name, value) {
    try {
        return sessionStorage.setItem(name, value);
    }
    catch (e) {
        // console.error(e);
        return set(storage.sessionStorage, name, value);
    }
};
export var getLocalStore = function (name) {
    try {
        return localStorage.getItem(name);
    }
    catch (e) {
        // console.error(e);
        return get(storage.localStorage, name);
    }
};
export var setLocalStore = function (name, value) {
    if (typeof value === "object") {
        value = JSON.stringify(value);
    }
    try {
        return localStorage.setItem(name, value);
    }
    catch (e) {
        // console.error(e);
        return set(storage.localStorage, name, value);
    }
};
var PARTICIPANT_DATA_KEY = "ws-participant-data";
export var setParticipantForm = function (state) {
    if (state === null || state === void 0 ? void 0 : state.shouldSaveParticipant) {
        setLocalStore(PARTICIPANT_DATA_KEY, state.participantDataToSave);
        savedParticipantForm = state.participantDataToSave;
    }
    else {
        setLocalStore(PARTICIPANT_DATA_KEY, {});
        savedParticipantForm = {};
    }
};
export var getParticipantForm = function () {
    return JSON.parse(getLocalStore(PARTICIPANT_DATA_KEY) || "{}");
};
var savedParticipantForm = getParticipantForm();
export var loadState = function (integrationName, storeKey) {
    try {
        var serializedState = getSessionStore(storeKey);
        var persistentState = getPersistentStore(integrationName);
        var appReducerWithIntegrationName = set({}, "appReducer", {
            integrationName: integrationName,
            stripUrlPath: integrationName === defaultAdminIntegrationName,
            savedParticipantForm: integrationName === defaultAdminIntegrationName ? null : savedParticipantForm,
        });
        if (serializedState === null && persistentState === null) {
            return appReducerWithIntegrationName;
        }
        return merge({}, serializedState && JSON.parse(serializedState), persistentState, appReducerWithIntegrationName, {
            globalReducer: {
                isLoggedIn: false,
            }
        });
    }
    catch (err) {
        return undefined;
    }
};
export var saveState = function (storeKey, state) {
    try {
        var integrationName = get(state, "appReducer.integrationName");
        var stateClone = cloneDeep(state);
        var filteredState = pick(stateClone, ["appReducer", "formReducer"]);
        var formReducer_1 = get(filteredState, "formReducer.forms");
        var filteredFormReducerForms = keys(formReducer_1).reduce(function (forms, formKey) {
            forms[formKey] = formKey === "payment-form" ? formReducer_1[formKey] : pick(formReducer_1[formKey], "form_data", ADMIN_SETTINGS_KEY, "additional_props");
            forms[formKey] = unset("formKey.additional_props.search_n_select", forms);
            return forms;
        }, {});
        set(filteredState, "formReducer.forms", filteredFormReducerForms);
        set(filteredState, "appReducer.flashNotifications", {});
        var serializedState = JSON.stringify(filteredState);
        setSessionStore(storeKey, serializedState);
        setPersistentStore(integrationName, pickPersistentState(state));
    }
    catch (_a) {
        // ignore write errors
    }
};
export var getPersistentStoreKey = function (integrationName) {
    return STORE_KEY + "-" + integrationName;
};
var getPersistentStore = function (integrationName) {
    var store = getLocalStore(getPersistentStoreKey(integrationName));
    return store && JSON.parse(store);
};
var setPersistentStore = function (integrationName, state) {
    var persistentState = JSON.stringify(pickPersistentState(state));
    setLocalStore(getPersistentStoreKey(integrationName), persistentState);
};
export var pushToGlobalStore = function (integrationName, _a) {
    var _b = _a.form, form = _b === void 0 ? null : _b, _c = _a.checkoutContext, checkoutContext = _c === void 0 ? CHECKOUT_CONTEXT_ENUM.BOOK_NOW : _c;
    var store = pickPersistentState(getPersistentStore(integrationName));
    setPersistentStore(integrationName, set(store, "globalReducer", { form: form, checkoutContext: checkoutContext }));
};
export var pickPersistentState = function (state) {
    return pick(state, "cartReducer", "globalReducer");
};
